var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import cxs from 'cxs/component';
import Theme from 'Theme';
import { TimePicker } from 'elements';
var FieldTime = /** @class */ (function (_super) {
    __extends(FieldTime, _super);
    function FieldTime() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FieldTime.prototype.render = function () {
        var _a = this.props, hora = _a.hora, name = _a.name, required = _a.required, onChange = _a.onChange;
        return (React.createElement(TimePicker, { name: name, hora: hora, onChange: onChange }));
    };
    return FieldTime;
}(Component));
export default FieldTime;
var Label = cxs('label')({
    padding: Theme.size.space[1],
    color: Theme.color.placeholder
});



//////////////////
// WEBPACK FOOTER
// ./src/elements/FieldTime.tsx
// module id = 1013
// module chunks = 0